import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { WaitLoadingModule } from '../../components/common/waitLoading/waitLoading.module';
import { UserModule } from '../../user/user/user.module';
import { DossierHeaderModule } from '../components/dossierHeader.module';
import { DialogService, DynamicDialogModule } from 'primeng-lts/dynamicdialog';
import { TranslateModule } from '@ngx-translate/core';
import { CommunicationsComponent } from './communications.component';
import { TableModule } from 'primeng-lts/table';
import { SubHeaderModule } from '../../components/common/sub-header/sub-header.module';
import { CommunicationEditionComponent } from './communication.edition.component';
import { formPlycaComponent } from '../../components/forms/formPlyca.component';
import { FormPlycaModule } from '../../components/forms/formPlyca.module';
import { searchOrganizationalUnitsModule } from '../../components/searchOrganizationalUnits/searchOrganizationalUnits.module';
import { CommunicationFieldDocsComponent } from './fields/communication.field-docs.component';
import { CommunicationFieldToComponent } from './fields/communication.field-to.component';
import { CommunicationFieldFromComponent } from './fields/communication.field-from.component';
import { CommunicationActionsComponent } from './commmunication.actions.component';
import { ButtonModule } from 'primeng-lts/button';
import { ChipsModule } from 'primeng-lts/chips';
import { DialogModule } from 'primeng-lts/dialog';
import { ListboxModule } from 'primeng-lts/listbox';
import { MenuModule } from 'primeng-lts/menu';
import { MultiSelectModule } from 'primeng-lts/multiselect';
import { OverlayPanelModule } from 'primeng-lts/overlaypanel';
import { PanelModule } from 'primeng-lts/panel';
import { ScrollPanelModule } from 'primeng-lts/scrollpanel';
import { TabViewModule } from 'primeng-lts/tabview';
import { TooltipModule } from 'primeng-lts/tooltip';
import { TreeModule } from 'primeng-lts/tree';
import { FieldsetModule } from 'primeng-lts/fieldset';
import { RadioButtonModule } from 'primeng-lts/radiobutton';
import { PMenuActionsModule } from '../../actions/pmenu.actions.module';

@NgModule({
  declarations: [CommunicationsComponent,
    CommunicationEditionComponent,
    CommunicationFieldFromComponent,
    CommunicationFieldToComponent,
    CommunicationActionsComponent,
    CommunicationFieldDocsComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FormPlycaModule,

    TabViewModule,
    MultiSelectModule,
    DossierHeaderModule,
    WaitLoadingModule,
    DynamicDialogModule,
    RadioButtonModule,
    TableModule,
    FieldsetModule,
    ListboxModule,
    RouterModule,
    UserModule,
    PanelModule,
    TranslateModule,
    TooltipModule,
    DialogModule,
    ButtonModule,
    ChipsModule,
    MenuModule,
    TreeModule,
    OverlayPanelModule,
    ScrollPanelModule,
    SubHeaderModule,
    searchOrganizationalUnitsModule,
    PMenuActionsModule
  ],
  providers: [DialogService],
  entryComponents: [formPlycaComponent,
    CommunicationFieldFromComponent,
    CommunicationFieldToComponent,
    CommunicationActionsComponent,
    CommunicationFieldDocsComponent]
})
export class CommunicationsModule { }
